import Link from 'next/link'
import { cn } from '@/lib/utils'

const dark = 'https://heyboss.heeyo.ai/logo-dark.png'
// const light = 'https://heyboss.heeyo.ai/logo-light.png'
const light = 'https://heyboss.heeyo.ai/design-system/logo_CHq-pgqg.png'

// const cyber = 'https://heyboss.heeyo.ai/design-system/heyboss-logo_BBI3fAdU.png'
const cyber = 'https://heyboss.heeyo.ai/design-system/logo_Oa2Hiv0Y.png'

interface LogoProps {
  openLinkInNewTab?: boolean
  variant?: 'light' | 'dark' | 'cyber'
  className?: string
}

export const Logo = ({
  variant = 'light',
  openLinkInNewTab = false,
  className,
}: LogoProps) => {
  const logo = variant === 'light' ? light : variant === 'dark' ? dark : cyber
  return (
    <Link
      href="/"
      target={openLinkInNewTab ? '_blank' : '_self'}
      className={cn(
        'text-2xl flex shrink-0 items-center gap-2 font-brand',
        className,
      )}
    >
      <img src={logo} alt="logo" className="h-10" />
    </Link>
  )
}
